import React, { useState } from 'react';
import './Navbar.css';
import logo from "../download.png";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  return React.createElement(
    React.Fragment,
    null,
    React.createElement(
      'nav',
      { className: 'navbar' },
      React.createElement(
        'div',
        { className: 'navbar-logo' },
        React.createElement('img', { src: logo, alt: '' }),
        React.createElement('span', null, 'Help Centre')
      ),
      React.createElement(
        'div',
        { className: 'check' },
        React.createElement('i', { className: 'fas fa-search', style: { marginRight: '20px', fontSize: '25px' } })
      ),
      React.createElement('input', {
        type: 'checkbox',
        id: 'check',
        checked: isOpen,
        onChange: toggleNavbar
      }),
      React.createElement(
        'label',
        { htmlFor: 'check', className: 'checkbtn' },
        React.createElement('i', { className: isOpen ? 'fas fa-times' : 'fas fa-bars' })
      ),
      React.createElement(
        'div',
        { className: 'navbar-search-container' },
        React.createElement(
          'div',
          { className: 'navbar-search' },
          React.createElement(
            'button',
            { className: 'search-btn' },
            React.createElement('i', { className: 'fas fa-search' })
          ),
          React.createElement('input', { type: 'text', placeholder: 'Search help articles...' })
        ),
        React.createElement(
          'aside',
          { className: 'navbar-sidebar' },
          React.createElement(
            'ul',
            null,
            React.createElement(
              'li',
              { className: 'sidebar-item' },
              React.createElement(
                'div',
                { className: 'icon-circle' },
                React.createElement('i', { className: 'far fa-compass' })
              ),
              'Using Fасebооk',
              React.createElement('span', { className: 'arrow' })
            ),
            React.createElement(
              'li',
              { className: 'sidebar-item' },
              React.createElement(
                'div',
                { className: 'icon-circle' },
                React.createElement('i', { className: 'fas fa-user' })
              ),
              'Managing your account',
              React.createElement('span', { className: 'arrow' })
            ),
            React.createElement(
              'li',
              { className: 'sidebar-item' },
              React.createElement(
                'div',
                { className: 'icon-circle' },
                React.createElement('i', { className: 'fas fa-lock' })
              ),
              'Privacy, safety and security',
              React.createElement('span', { className: 'arrow' })
            ),
            React.createElement(
              'li',
              { className: 'sidebar-item' },
              React.createElement(
                'div',
                { className: 'icon-circle' },
                React.createElement('i', { className: 'fas fa-info-circle' })
              ),
              'Policies and reporting',
              React.createElement('span', { className: 'arrow' })
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'navbar-icon' },
          React.createElement('img', {
            className: 'profile-image',
            src: 'data:image/png;base64,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' ,
            alt: ''
          })
        ),
        React.createElement(
          'div',
          { className: 'navbar-lang' },
          React.createElement(
            'button',
            { className: 'lang-btn' },
            'English (US)'
          ),
          React.createElement('i', { className: 'fas fa-caret-down' })
        )
      )
    )
  );
};

export default Navbar;
